<template>
	<div class="content_yf">
		<img src="@/assets/imgs/screen/pic_bg3.jpg" alt="" class="bg_yf">

		<div class="left_box_yf">
			<div class="left_top_yf" style="height: 670px;">
				<img src="@/assets/imgs/screen/list_member.png" alt="" style="height: 670px;" class="list_member">
				<h3 style="top: 25px;">各车队新能源车辆数</h3>
				<ul>
					<li v-for="(item,index) in cardate" :key="index">
						<img src="@/assets/imgs/screen/icon_gas.png" alt="" class="icon_oil">
						<p>{{ item.name }}<CountTo ref="refcountofore" :duration="2000" :start-val="startVal"
								:end-val="item.value" :decimals="0"></CountTo>
						</p>
					</li>
				</ul>
				<div class="heji">
					<img src="@/assets/imgs/screen/icon_energy.png" alt="" class="icon_oil">
						<p>合计<CountTo ref="refcountofore" :duration="2000" :start-val="startVal"
								:end-val="totalcarcount" :decimals="0"></CountTo>
						</p>
				</div>
			</div>
			<!-- <div class="left_top_yf">
				<img src="@/assets/imgs/screen/list_member.png" alt="" class="list_member">
				<h3>作业中各类车辆</h3>
				<ul>
					<li>
						<img src="@/assets/imgs/screen/icon_oil.png" alt="" class="icon_oil">
						<p>燃油车辆<CountTo ref="refcountofore" :duration="2000" :start-val="startVal"
								:end-val="parseInt(newenergyData.working_fuel)" :decimals="0"></CountTo>
						</p>
					</li>
					<li>
						<img src="@/assets/imgs/screen/icon_gas.png" alt="" class="icon_oil">
						<p>天然气车辆<CountTo ref="refcountofore" :duration="2000" :start-val="startVal"
								:end-val="parseInt(newenergyData.working_natural_gas)" :decimals="0"></CountTo>
						</p>
					</li>
					<li>
						<img src="@/assets/imgs/screen/icon_energy.png" alt="" class="icon_oil">
						<p>新能源车辆<CountTo ref="refcountofore" :duration="2000" :start-val="startVal"
								:end-val="parseInt(newenergyData.working_new_energy)" :decimals="0"></CountTo>
						</p>
					</li>
				</ul>
			</div> -->
			<div class="left_top_yf">
				<img style="height: 290px;" src="@/assets/imgs/screen/list_policy.png" alt="" class="list_member">
				<h3 class="policy_yf">运输里程统计</h3>
				<!-- <p class="criterion">{{ removeTags(noticeData.notice_context) || noticeData.notice_context }}</p> -->
				<!-- <p class="criterion" >{{noticeData.notice_context }}</p> -->
				<ul class="list_yf">
					<li class="list_yf_li">
						<p class="list_yf_li_p_num">
							<CountTo ref="refcountofore" :duration="2000" :start-val="startVal" :end-val="jieTan.totalMileage" :decimals="0">
				</CountTo></p>
						<p class="list_yf_li_p">累计运输里程(公里)</p>	
					</li>
					<li class="list_yf_li">
						<p class="list_yf_li_p_num">
							<CountTo ref="refcountofore" :duration="2000" :start-val="startVal" :end-val="jieTan.mileageReduce" :decimals="2">
				</CountTo></p>
						<p class="list_yf_li_p">百公里减少碳排放(千克)</p>
					</li>
				</ul>
			</div>
		</div>
		<div class="right_top_yf">
			<img src="@/assets/imgs/screen/icon_safe.png" alt="">
			<h4>历年累计碳排放量减少</h4>
			<p>
				参考数据：1升柴油=2.63千克“二氧化碳”=0.717千克“碳”。49吨重卡百公里耗柴油约40L，即碳排放量为28.68kg，二氧化碳排放量为：105.2kg
			</p>
			<!-- <span class="triangle"></span> -->
		</div>
		<div class="right_center_yf">
			<img src="@/assets/imgs/screen/pic_sigit.png" alt="" class="pic_sigit">
			<img src="@/assets/imgs/screen/pic_arrow_y.png" alt="" class="pic_arrow_y">
			<img src="@/assets/imgs/screen/pic_arrow_z.png" alt="" class="pic_arrow_z">
			<p>
				<CountTo ref="refcountofore" :duration="2000" :start-val="startVal" :end-val="jieTan.historyReduce" :decimals="0">
				</CountTo>
				<span class="dun">吨</span>
			</p>
		</div>
	</div>
</template>

<script>
	import CountTo from 'vue-count-to';
	import axios from "axios";
	export default {
		data() {
			return {
				startVal: 0,
				jieTan: {},
				noticeData: {},
				yardinfo: {},
				newenergyData: {
					"new_energy": "0", //新能源车辆
					"fuel": "0", //燃油车辆
					"working_fuel": "0", //作业中燃油车辆
					"working_natural_gas": "0", //作业中天然气车辆
					"working_new_energy": "0", //作业中新能源车辆
					"natural_gas": "0" //天然气车辆

				},
				cardate:[],
				totalcarcount:0
			};
		},
		computed: {

		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.getIndexData();
			this.getJieTan();

			// this.getIndexData_timer_energy = setInterval(this.getIndexData, 5000);

			// this.getJieTan_timer = setInterval(this.getJieTan, 10000);
		},
		beforeDestroy() {
			clearInterval(this.getIndexData_timer_energy);
			// clearInterval(this.getJieTan_timer);
		},
		methods: {
			getJieTan() {
				axios({
					method: 'get',
					url: `${this.$bigScreenApiBase}big/screen/calculateCarbon `,
					headers:{
					token:JSON.parse(decodeURIComponent(window.sessionStorage.getItem("user"))).token
				}
				}).then(
					(res) => {
						
						this.jieTan = res.data.data
					},
					(err) => {
						console.log(err);
					},
				)
			},
			getIndexData() {
				axios({
					method: 'get',
					url: `${this.$bigScreenApiBase}big/screen/fleetCarsCount`,
					headers:{
					token:JSON.parse(decodeURIComponent(window.sessionStorage.getItem("user"))).token
				}
				}).then(
					(res) => {
						this.cardate = res.data.data.sort((a,b)=>{
							return b.value-a.value
						})
						this.totalcarcount=this.cardate.reduce((a,b)=>{
							return a+b.value
						},0)
					},
					(err) => {
						console.log(err);
					},
				)


				// axios({
				// 	method: 'get',
				// 	url: `${this.$bigScreenApiBase}/dv/notice`
				// }).then(
				// 	(res) => {
				// 		console.log(res)
				// 		this.noticeData = res.data.data
				// 	},
				// 	(err) => {
				// 		console.log(err);
				// 	},
				// )
			},
			removeTags(value) {
				if (!value) {
					return ''
				}
				return value.replace(/<[^>]+>|&nbsp;/g, ' ')
			}

		},
		components: {
			CountTo
		},
	};
</script>

<style lang="scss" scoped>
	::-webkit-scrollbar {
		display: none;
	}

	#root {
		overflow: hidden;
	}

	.left_box_yf {
		position: absolute;
		left: 28px;
		top: 90px;
		color: #fff;

		.left_top_yf {
			position: relative;
			width: 530px;
			margin-bottom: 18px;

			h3 {
				font-size: 18px;
				text-align: center;
				font-family: Source Han Sans CN;
				position: absolute;
				top: 14px;
				width: 100%;
				font-weight: bold;
				color: #FFFFFF;

				&.policy_yf {
					width: 95%;
					white-space: nowrap;
					overflow-y: auto;
					left: 20px;
					top: 14px;
				}
			}
			.list_yf{
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 70%;
				.list_yf_li{
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					.list_yf_li_p_num{
						line-height: 50px;
						font-size: 36px;
						font-family: stymixb;
						font-weight: bold;
						color: #05FFFF;
					}
					.list_yf_li_p{
						line-height: 50px;
						margin-right: 26px;
					}
				}
			}
			.heji{
				position: absolute;
				bottom: 0;
				left: 20px;
				width: 492px;
				height: 72px;
				background: rgba(9, 34, 71, 0.6);
				margin-bottom: 5px;
				display: flex;
				align-items: center;
				img {
					width: 60px;
					height: 60px;
					margin: 6px;

				}

				p {
					margin-left: 28px;
					font-size: 16px;
					flex: 1;
					margin-right: 34px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #FFFFFF;
					line-height: 60px;

					span {
						font-size: 36px;
						font-family: stymixb;
						font-weight: bold;
						color: #05FFFF;
						float: right;
					}
					
				}
				img {
						&:hover {
							animation: bounce 1s linear 0s 1 normal;
						}
					}
			}
			ul {
				position: absolute;
				top: 59px;
				left: 20px;
				width: 492px;
				height: calc(100% - 135px);
				overflow-y: scroll;
				li {
					width: 100%;
					// height: 72px;
					background: rgba(9, 34, 71, 0.6);
					margin-bottom: 5px;
					display: flex;
					align-items: center;

					img {
						width: 60px;
						height: 60px;
						margin: 6px;

					}

					p {
						margin-left: 28px;
						font-size: 16px;
						flex: 1;
						margin-right: 34px;
						font-family: Source Han Sans CN;
						font-weight: bold;
						color: #FFFFFF;
						line-height: 60px;

						span {
							font-size: 36px;
							font-family: stymixb;
							font-weight: bold;
							color: #05FFFF;
							float: right;
						}
					}

					&:nth-child(1) {
						img {
							animation: 1s ease 0s 1 normal both running zoomIn;
						}
					}

					&:nth-child(2) {
						img {
							animation: 1s ease 0.5s 1 normal both running zoomIn;
						}
					}

					&:nth-child(3) {
						img {
							animation: 1s ease 1s 1 normal both running zoomIn;
						}
					}

					img {
						&:hover {
							animation: bounce 1s linear 0s 1 normal;
						}
					}
				}
			}

			.criterion {
				font-size: 18px;
				color: #08a4fb;
				padding: 0 13px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				position: absolute;
				top: 70px;
				line-height: 2;
				width: 95%;
				height: 220px;
				overflow: auto;
			}

		}
	}

	.right_top_yf {
		position: absolute;
		left: 644px;
		top: 111px;
		display: flex;
		align-items: center;
		cursor: pointer;

		h4 {
			font-size: 30px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #4BDFFF;
			margin-top: -20px;
			margin-right: 26px;
			line-height: 68px;
		}

		p {
			width: 685px;
			font-size: 14px;
			display: none;
			font-family: Source Han Sans CN;
			font-weight: 400;
			border-radius: 10px;
			color: #FFFFFF;
			margin-left: 18px;
			line-height: 36px;

		}

		.triangle {
			display: block;
			border-right: 21px solid #3195ab;
			border-top: 20px solid transparent;
			border-bottom: 20px solid transparent;
			display: none;
			position: absolute;
			left: 436px;
			bottom: 46px;
		}

		&:hover {

			.triangle,
			p {
				display: block;
			}
		}
	}

	.right_center_yf {
		position: absolute;
		left: 752px;
		top: 267px;

		.pic_sigit {
			width: 746px;
			height: 167px;
		}

		p {
			position: absolute;
			left: 0;
			top: 10px;
			width: 100%;
			text-align: center;
			font-size: 87px;
			font-family: stymixb;
			font-weight: normal;
			color: #32EDC2;

			.dun {
				font-size: 30px;
				color: #fff;
			}
		}

		.pic_arrow_y {
			position: absolute;
			left: 106px;
			top: 140px;
			animation: arrowmove 4s linear 0s infinite normal;
		}

		.pic_arrow_z {
			position: absolute;
			left: 522px;
			top: 140px;
			animation: arrowmove 5s linear 0.5s infinite normal;
		}

		@keyframes zoomIn {
			0% {
				opacity: 0;
				-webkit-transform: scale3d(.3, .3, .3);
				transform: scale3d(.3, .3, .3)
			}

			50% {
				opacity: 1
			}
		}

		@keyframes arrowmove {
			0% {
				transform: translateX(0);
				opacity: 0;
			}

			25% {
				transform: translateX(-10px);
				opacity: 0.25;
			}

			50% {
				transform: translateX(0px);
				opacity: 0.5;
			}

			75% {
				transform: translateX(10px);
				opacity: 0.75;
			}

			100% {
				transform: translateX(0);
				opacity: 1;
			}
		}
	}
</style>